import styled from '@emotion/styled';
import { createStyles, rem } from '@mantine/core';

export const useHomeScrollAreaStyles = createStyles((theme) => ({
  root: {
    maxHeight: 'calc(100svh - 320px)',
    // border: '1px solid black',
  },
}));

export const useSearchBarStyles = createStyles((theme) => ({
  gridContainer: {
    // border: '1px solid black',
    padding: 0,
    margin: 0,
  },

  gridCol: {
    padding: 0,
    margin: 0,
    WebkitFlexShrink: 0,
    flexShrink: 0,
    WebkitFlexGrow: 0,
    flexGrow: 0,
    ':-ms-flex-negative': 0,
    ':-ms-flex-positive': 0,
    ':-webkit-box-flex': 0,
  },

  searchBarGridColumn: {
    WebkitFlexBasis: `${(11 / 12) * 100}%`,
    flexBasis: `${(11 / 12) * 100}%`,
    maxWidth: `${(11 / 12) * 100}%`,
    ':-ms-flex-preferred-size': `${(11 / 12) * 100}%`,
  },

  qrCodeGridColumn: {
    WebkitFlexBasis: `${(1 / 12) * 100}%`,
    flexBasis: `${(1 / 12) * 100}%`,
    maxWidth: `${(1 / 12) * 100}%`,
    ':-ms-flex-preferred-size': `${(1 / 12) * 100}%`,
  },

  searchWrapperBox: {
    height: '100%',
    width: '100%',
    padding: `${rem(8)} ${rem(4)}`,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },

  qrCodeWrapperBox: {
    width: 54,
    height: 54,
    backgroundColor: 'white',
    borderRadius: 12,
    padding: 8,
    boxShadow: '0px 4px 11px 0px rgba(0,0,0,0.1)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    userSelect: 'none',
    cursor: 'pointer',
  },

  qrCodeImageContainer: {
    // border: '1px solid black',
    // boxShadow:
    //   '0px 2px 4px 0px rgba(0,0,0,0.1),0px -2px 4px 0px rgba(0,0,0,0.1),2px 0px 4px 0px rgba(0,0,0,0.1),-2px 0px 4px 0px rgba(0,0,0,0.1)',
    borderRadius: 4,
    padding: 4,
    height: 52,
    width: 52,
    cursor: 'pointer',
  },
}));

export const useTrendingTodayStyles = createStyles((theme) => ({
  gridContainer: {
    padding: 0,
    margin: 0,
    marginTop: 5,
  },

  gridCol: {
    WebkitFlexShrink: 0,
    flexShrink: 0,
    WebkitFlexGrow: 0,
    flexGrow: 0,
    ':-ms-flex-negative': 0,
    ':-ms-flex-positive': 0,
    ':-webkit-box-flex': 0,
  },

  trendingTodayGridCol: {
    WebkitFlexBasis: `${(3 / 12) * 100}%`,
    flexBasis: `${(3 / 12) * 100}%`,
    maxWidth: `${(3 / 12) * 100}%`,
    ':-ms-flex-preferred-size': `${(3 / 12) * 100}%`,
  },

  sliderGridCol: {
    WebkitFlexBasis: `${(9 / 12) * 100}%`,
    flexBasis: `${(9 / 12) * 100}%`,
    maxWidth: `${(9 / 12) * 100}%`,
    ':-ms-flex-preferred-size': `${(9 / 12) * 100}%`,
  },
  container: {
    cursor: 'pointer',
    marginInline: 16,
    width: 80,
  },

  imageContainer: {
    borderRadius: 16,
    padding: 3,
    backgroundColor: theme.colors.chrome[7],
    boxShadow: '0px 24px 24px -8px rgba(0,0,0,0.1)',
  },
}));

export const useCuisineBadgeStyles = createStyles((theme) => ({
  badge: {
    cursor: 'pointer',
    userSelect: 'none',
    border: `0.0625rem solid ${theme.colors.magenta[9]}`,
    transition: '200ms',
  },

  unselectedBadge: {
    backgroundColor: theme.colors.magenta[0],
    color: theme.colors.magenta[9],
  },

  selectedBadge: {
    backgroundColor: theme.colors.magenta[9],
    color: 'white',
  },
}));

export const RestaurantsNearbyScrollArea = styled.div(({}) => ({
  maxHeight: '100svh',
  paddingBottom: 5,
  overflowY: 'auto',
  height: 'calc(100svh - 360px)',
  '&.without__trending__items': {
    height: 'calc(100svh - (360px - 80px))',

    [`@media (max-width: 665px)`]: {
      height: 'calc(100svh - (385px - 55px))',
    },
  },
  [`@media (max-width: 665px)`]: {
    height: 'calc(100svh - 385px)',
  },

  '&::-webkit-scrollbar': {
    width: 2,
  },
  '&:hover': {
    '&::-webkit-scrollbar-thumb': {
      background: '#888',
      borderRadius: 10,
    },
  },
}));

export const useRestaurantCardStyles = createStyles((theme) => ({
  container: {
    cursor: 'pointer',
    userSelect: 'none',
    border: '0.0625rem solid #dee2e6',
    backgroundColor: 'white',
    borderRadius: 16,
    boxShadow:
      '0 0.0625rem 0.1875rem rgba(0, 0, 0, 0.05), rgba(0, 0, 0, 0.05) 0 1.75rem 1.4375rem -0.4375rem, rgba(0, 0, 0, 0.04) 0 0.75rem 0.75rem -0.4375rem',
  },

  restaurantName: {
    color: theme.colors.magenta[9],
    lineHeight: 1,
    fontWeight: 500,
    fontSize: 18,

    [theme.fn.smallerThan(412)]: {
      lineHeight: 1,
      fontWeight: 500,
      fontSize: 16,
    },
  },

  ratingStar: {
    cursor: 'pointer',
    svg: {
      width: 16,
      height: 16,

      [theme.fn.smallerThan(412)]: {
        width: 13,
        height: 13,
      },
    },
  },

  ratingCount: {
    lineHeight: 1,
    fontWeight: 400,
    fontSize: 14,
    color: theme.colors.dark[6],
  },

  openingTimingsText: {
    lineHeight: 1,
    fontWeight: 500,
    fontSize: 12,

    [theme.fn.smallerThan('sm')]: {
      fontSize: 11,
    },
  },

  openingTimingsTiming: {
    lineHeight: 1,
    fontWeight: 500,
    fontSize: 12,
    color: theme.colors.blue[6],

    [theme.fn.smallerThan('sm')]: {
      fontSize: 11,
    },
  },

  gridCol: {
    WebkitFlexShrink: 0,
    flexShrink: 0,
    WebkitFlexGrow: 0,
    flexGrow: 0,
    ':-ms-flex-negative': 0,
    ':-ms-flex-positive': 0,
    ':-webkit-box-flex': 0,
  },

  imageGridCol: {
    WebkitFlexBasis: `${(4 / 12) * 100}%`,
    flexBasis: `${(4 / 12) * 100}%`,
    maxWidth: `${(4 / 12) * 100}%`,
    ':-ms-flex-preferred-size': `${(4 / 12) * 100}%`,
    paddingRight: 0,
    // height: 'auto',
  },

  detailsGridCol: {
    WebkitFlexBasis: `${(8 / 12) * 100}%`,
    flexBasis: `${(8 / 12) * 100}%`,
    maxWidth: `${(8 / 12) * 100}%`,
    ':-ms-flex-preferred-size': `${(8 / 12) * 100}%`,
  },
}));
